import {useEffect, useState} from 'react'
import {WithTranslation, withTranslation} from 'react-i18next'
import {useLocation, useNavigate} from 'react-router-dom'

import TabBar, {Section} from '../../components/TabBar/TabBar'
import {PATHS} from '../../constants/paths'
import BannerContainer from '../../containers/BannerContainer'
import BannerSection from '../../containers/BannerSection'
import {useUser} from '../../contexts/UserContext'
import {useCustomerSlice} from '../../store/slices/customer'

import {PANEL_SECTION, panelSections, sections} from './sections/constants'

import styles from './Panel.module.scss'

const Panel = ({}: WithTranslation) => {
  const {user} = useUser()
  const navigate = useNavigate()
  const {state} = useLocation()
  const {
    customer_info: {group},
  } = useCustomerSlice()
  const [activeSection, selectSection] = useState<Section>(
    state?.panelSection
      ? panelSections.find(
          section =>
            section.section.keyLabel === (state.panelSection as keyof typeof PANEL_SECTION),
        )?.section || panelSections[0].section
      : panelSections[0].section,
  )

  useEffect(() => {
    if ((!!group && group !== 'project-admin') || !user) navigate(PATHS.HOME)
  }, [group, user, navigate])

  return (
    <BannerSection className={styles.section}>
      <BannerContainer className={styles.container} layout="column">
        <TabBar
          onChangeSection={selection => {
            window.history.replaceState({panelSection: ''}, '')
            selectSection(selection)
          }}
          sections={sections}
          activeSection={activeSection}
        />
        <div className={styles.line} />
        {
          panelSections.find(
            panelSection => panelSection.section.keyLabel === activeSection.keyLabel,
          )?.sectionComponent
        }
      </BannerContainer>
    </BannerSection>
  )
}

export default withTranslation()(Panel)
